<template>
  <div v-if="!isLoading">
    <div class="body-2 mt-8 flex justify-between">
      <div class="flex">
        <div>{{ i18n(translations.installment) }}</div>

        <PaymentIcons class="ml-1" :methods="[selectedPaymentMethod]" />
      </div>
      <div class="ml-24">
        {{ i18n.price(simulation?.cost ?? '') }}
      </div>
    </div>

    <RevDivider class="my-16" />

    <div class="body-1-bold mt-8 flex justify-between">
      <div>{{ totalTitle }}</div>
      <div class="ml-24">
        {{ i18n.price(simulation?.totalAmount ?? '') }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PaymentMethod } from '@backmarket/http-api/src/api-specs-payment/payment/payment.types'
import type { LoanSimulation } from '@backmarket/nuxt-layer-payment/api/getLoanSimulation/getLoanSimulation.specs'
import { PaymentIcons } from '@backmarket/nuxt-layer-payment/methods'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDivider } from '@ds/components/Divider'

import translations from './Installments.translations'

const i18n = useI18n()

defineProps<{
  isLoading: boolean
  simulation: LoanSimulation | null
  selectedPaymentMethod: PaymentMethod
  totalTitle: string
}>()
</script>
